// extracted by mini-css-extract-plugin
export default {"root":"jLHxYZ","container":"XAE9AO","text":"GmNnjO","block":"NTR9Xm"};